import type { FlightItem } from '../types/flight.types';

export function getFlightItemKey(flight: FlightItem, index?: number): string {
  const base = [
    flight.depart_flight_number,
    flight.depart_departure_date_time,
    flight.depart_arrival_date_time,
    flight.depart_departure_airport,
    flight.depart_arrival_airport,
    flight.depart_airline,
    flight.depart_stop_number,
    flight.depart_stops_airports ?? '',
    flight.return_flight_number ?? '',
    flight.return_departure_date_time ?? '',
    flight.return_arrival_date_time ?? '',
    flight.return_airline ?? '',
    flight.return_stop_number ?? '',
    flight.price,
  ].join('-');

  return index !== undefined ? `${base}-${index}` : base;
}
